import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "view__header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "view__header_title" }, "Заказы")
], -1)
const _hoisted_2 = { class: "view-table box" }
const _hoisted_3 = { class: "view-table__header" }
const _hoisted_4 = { class: "view-table__description" }
const _hoisted_5 = { class: "view-table__pagination" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Страница", -1)
const _hoisted_8 = ["max"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "из", -1)
const _hoisted_10 = {
  key: 0,
  class: "table is-bordered"
}
const _hoisted_11 = { style: {"width":"40px"} }
const _hoisted_12 = ["checked"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"200px"} }, "ФИО", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"100px"} }, "Аккаунт", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"50px"} }, "Дубли ИНН", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"100px"} }, "Дата", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"100px"} }, "БИК банка", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"100px"} }, "Расчетный счет", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"100px"} }, "Сумма", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"100px"} }, "Статус", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"100px"} }, "Пользователь", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"100px"} }, "Дата выгрузки", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"100px"} }, "Дата выплаты", -1)
const _hoisted_24 = ["value"]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("a", null, "Подробно", -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("th", null, "Итого", -1)
const _hoisted_47 = { class: "has-text-weight-bold" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_51 = {
  key: 1,
  class: "table-container__empty"
}
const _hoisted_52 = {
  key: 0,
  class: "view-table_options"
}
const _hoisted_53 = { class: "view-table_options__content box is-radiusless" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Поиск", -1)
const _hoisted_55 = { class: "field has-addons" }
const _hoisted_56 = { class: "control" }
const _hoisted_57 = { class: "select" }
const _hoisted_58 = ["value"]
const _hoisted_59 = { class: "control is-expanded has-icons-right" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = { class: "field" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Статус", -1)
const _hoisted_64 = { class: "control" }
const _hoisted_65 = { class: "select" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Не имеет значения", -1)
const _hoisted_67 = ["value"]
const _hoisted_68 = { class: "field" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Выгружено", -1)
const _hoisted_70 = { class: "control control__date" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("span", null, "От", -1)
const _hoisted_72 = { class: "control control__date" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("span", null, "До", -1)
const _hoisted_74 = { class: "field mt-auto" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Показывать по", -1)
const _hoisted_76 = { class: "control" }
const _hoisted_77 = { class: "select" }
const _hoisted_78 = ["value"]
const _hoisted_79 = { class: "field" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Сортировка", -1)
const _hoisted_81 = { class: "control" }
const _hoisted_82 = { class: "select" }
const _hoisted_83 = ["value"]
const _hoisted_84 = { class: "view-table_options__actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_ChangeOrderStatusForm = _resolveComponent("ChangeOrderStatusForm")!
  const _component_BaseModal = _resolveComponent("BaseModal")!
  const _component_ModalCard = _resolveComponent("ModalCard")!
  const _component_ModalDoubles = _resolveComponent("ModalDoubles")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, "Всего найдено " + _toDisplayString(_ctx.ctx.meta.total), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "button is-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openStatusModal && _ctx.openStatusModal(...args))),
            disabled: _ctx.selectedItems.length === 0
          }, "Изменить статус", 8, _hoisted_6),
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            class: "input",
            type: "number",
            min: "1",
            max: _ctx.ctx.meta.page.total,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.page) = $event)),
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePage()))
          }, null, 40, _hoisted_8), [
            [_vModelText, _ctx.page]
          ]),
          _hoisted_9,
          _createElementVNode("span", null, _toDisplayString(_ctx.ctx.meta.page.total), 1)
        ]),
        _createElementVNode("button", {
          class: "button is-info",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showOptions = true))
        }, "Опции")
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["table-container with-scrollbar", {'busy':_ctx.ctx.isLoading, 'lock': _ctx.showOptions}]),
        id: "table"
      }, [
        (_ctx.ctx.list.length)
          ? (_openBlock(), _createElementBlock("table", _hoisted_10, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_11, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleAll && _ctx.toggleAll(...args))),
                      checked: _ctx.allSelected && _ctx.hasSelectableItems
                    }, null, 40, _hoisted_12)
                  ]),
                  _hoisted_13,
                  _hoisted_14,
                  _hoisted_15,
                  _hoisted_16,
                  _hoisted_17,
                  _hoisted_18,
                  _hoisted_19,
                  _hoisted_20,
                  _hoisted_21,
                  _hoisted_22,
                  _hoisted_23
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ctx.list, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id,
                    class: _normalizeClass({'has-background-danger-light': item.is_limit && !item.status.is_lock})
                  }, [
                    _createElementVNode("td", null, [
                      (!item.status.is_lock)
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 0,
                            type: "checkbox",
                            value: item.id,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedItems) = $event))
                          }, null, 8, _hoisted_24)), [
                            [_vModelCheckbox, _ctx.selectedItems]
                          ])
                        : (_openBlock(), _createElementBlock("span", _hoisted_25))
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_router_link, {
                        to: { name: 'AgentsCard', params: { agent: item.agent.id } }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.agent.fullname), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createElementVNode("td", {
                      class: "is-hoverable",
                      onClick: ()=>_ctx.selected=item
                    }, _toDisplayString(item.agent.is_banned ? "Заблокирован" : "Активен"), 9, _hoisted_26),
                    (item.agent.doubles.length)
                      ? (_openBlock(), _createElementBlock("td", {
                          key: 0,
                          class: "is-hoverable",
                          onClick: ()=>_ctx.selectedAgent=item.agent
                        }, _hoisted_29, 8, _hoisted_27))
                      : (_openBlock(), _createElementBlock("td", {
                          key: 1,
                          class: "is-hoverable",
                          onClick: ()=>_ctx.selected=item
                        }, null, 8, _hoisted_30)),
                    _createElementVNode("td", {
                      class: "is-hoverable",
                      onClick: ()=>_ctx.selected=item
                    }, _toDisplayString(item.created_at), 9, _hoisted_31),
                    _createElementVNode("td", {
                      class: "is-hoverable",
                      onClick: ()=>_ctx.selected=item
                    }, _toDisplayString(item.bic), 9, _hoisted_32),
                    _createElementVNode("td", {
                      class: "is-hoverable",
                      onClick: ()=>_ctx.selected=item
                    }, _toDisplayString(item.check_acc), 9, _hoisted_33),
                    _createElementVNode("td", {
                      class: "is-hoverable",
                      onClick: ()=>_ctx.selected=item
                    }, _toDisplayString(item.amount), 9, _hoisted_34),
                    _createElementVNode("td", {
                      class: "is-hoverable",
                      onClick: ()=>_ctx.selected=item
                    }, _toDisplayString(item.status.system_name), 9, _hoisted_35),
                    _createElementVNode("td", {
                      class: "is-hoverable",
                      onClick: ()=>_ctx.selected=item
                    }, _toDisplayString(item.user?.name), 9, _hoisted_36),
                    _createElementVNode("td", {
                      class: "is-hoverable",
                      onClick: ()=>_ctx.selected=item
                    }, _toDisplayString(item.exported_at), 9, _hoisted_37),
                    _createElementVNode("td", {
                      class: "is-hoverable",
                      onClick: ()=>_ctx.selected=item
                    }, _toDisplayString(item.paid_at || '-'), 9, _hoisted_38)
                  ], 2))
                }), 128))
              ]),
              _createElementVNode("tfoot", null, [
                _createElementVNode("tr", null, [
                  _hoisted_39,
                  _hoisted_40,
                  _hoisted_41,
                  _hoisted_42,
                  _hoisted_43,
                  _hoisted_44,
                  _hoisted_45,
                  _hoisted_46,
                  _createElementVNode("th", _hoisted_47, _toDisplayString(_ctx.getTotalAmount()), 1),
                  _hoisted_48,
                  _hoisted_49,
                  _hoisted_50
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_51, "Пусто"))
      ], 2)
    ]),
    (_ctx.showOptions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
          _createElementVNode("div", {
            class: "view-table_options__overlay",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }),
          _createElementVNode("div", _hoisted_53, [
            _hoisted_54,
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("p", _hoisted_56, [
                _createElementVNode("span", _hoisted_57, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.search) = $event)),
                    onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.changeSearch && _ctx.changeSearch(...args)))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ctx.searchVariants, (s) => {
                      return (_openBlock(), _createElementBlock("option", { value: s }, _toDisplayString(s.name), 9, _hoisted_58))
                    }), 256))
                  ], 544), [
                    [_vModelSelect, _ctx.search]
                  ])
                ])
              ]),
              _createElementVNode("p", _hoisted_59, [
                (_ctx.search.param === 'search_fio')
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 0,
                      class: "input",
                      onType: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.text && _ctx.text(...args))),
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.searchFIO) = $event))
                    }, null, 544)), [
                      [_vModelText, _ctx.searchFIO]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.search.param === 'search_email')
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 1,
                      class: "input",
                      onType: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.text && _ctx.text(...args))),
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.searchEmail) = $event))
                    }, null, 544)), [
                      [_vModelText, _ctx.searchEmail]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.search.param === 'search_ref')
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 2,
                      class: "input",
                      onType: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.text && _ctx.text(...args))),
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.searchRef) = $event))
                    }, null, 544)), [
                      [_vModelText, _ctx.searchRef]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.search.param === 'search_promo')
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 3,
                      class: "input",
                      onType: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.text && _ctx.text(...args))),
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.searchPromo) = $event))
                    }, null, 544)), [
                      [_vModelText, _ctx.searchPromo]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.search.param === 'search_phone')
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 4,
                      class: "input",
                      onType: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.text && _ctx.text(...args))),
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.searchPhone) = $event))
                    }, null, 544)), [
                      [_vModelText, _ctx.searchPhone]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.search.param === 'search_inn')
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 5,
                      class: "input",
                      onType: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.text && _ctx.text(...args))),
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.searchInn) = $event))
                    }, null, 544)), [
                      [_vModelText, _ctx.searchInn]
                    ])
                  : _createCommentVNode("", true),
                _createElementVNode("span", {
                  class: "icon is-right is-clickable clear-field-icon has-text-dark",
                  onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.changeSearch && _ctx.changeSearch(...args)))
                }, _hoisted_61)
              ])
            ]),
            _createElementVNode("div", _hoisted_62, [
              _hoisted_63,
              _createElementVNode("p", _hoisted_64, [
                _createElementVNode("span", _hoisted_65, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.filterStatusId) = $event))
                  }, [
                    _hoisted_66,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (status) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: status.id
                      }, _toDisplayString(status.name), 9, _hoisted_67))
                    }), 256))
                  ], 512), [
                    [_vModelSelect, _ctx.filterStatusId]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_68, [
              _hoisted_69,
              _createElementVNode("p", _hoisted_70, [
                _hoisted_71,
                _createVNode(_component_DatePicker, {
                  class: "date",
                  date: _ctx.filterExportedAtFrom,
                  onUpdate: _cache[23] || (_cache[23] = (d)=>_ctx.filterExportedAtFrom=d)
                }, null, 8, ["date"])
              ]),
              _createElementVNode("p", _hoisted_72, [
                _hoisted_73,
                _createVNode(_component_DatePicker, {
                  class: "date",
                  date: _ctx.filterExportedAtTo,
                  onUpdate: _cache[24] || (_cache[24] = (d)=>_ctx.filterExportedAtTo=d)
                }, null, 8, ["date"])
              ])
            ]),
            _createElementVNode("div", _hoisted_74, [
              _hoisted_75,
              _createElementVNode("p", _hoisted_76, [
                _createElementVNode("span", _hoisted_77, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.limit) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ctx.LimitPageVariants, (variant) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: variant.value,
                        key: variant.name
                      }, _toDisplayString(variant.name), 9, _hoisted_78))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.limit]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_79, [
              _hoisted_80,
              _createElementVNode("p", _hoisted_81, [
                _createElementVNode("span", _hoisted_82, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.sorting) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ctx.sortingVariants, (variant) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: variant,
                        key: variant.name
                      }, _toDisplayString(variant.name), 9, _hoisted_83))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.sorting]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("button", {
                class: "button is-primary",
                onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.apply && _ctx.apply(...args)))
              }, "Применить"),
              _createElementVNode("button", {
                class: "button is-ghost",
                onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args)))
              }, "Сбросить"),
              _createElementVNode("button", {
                class: "button is-light",
                onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
              }, "Отмена")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_BaseModal, {
      "is-visible": _ctx.isStatusModalOpen,
      title: "Изменить статус",
      onClose: _ctx.closeStatusModal
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ChangeOrderStatusForm, {
          orderIds: _ctx.selectedItems,
          onSuccess: _ctx.onStatusChangeSuccess,
          onError: _ctx.onStatusChangeError,
          onClose: _ctx.closeStatusModal,
          ref: "statusForm"
        }, null, 8, ["orderIds", "onSuccess", "onError", "onClose"])
      ]),
      _: 1
    }, 8, ["is-visible", "onClose"]),
    _createVNode(_component_ModalCard, {
      order: _ctx.selected,
      onClose: () => {_ctx.selected = null}
    }, null, 8, ["order", "onClose"]),
    _createVNode(_component_ModalDoubles, {
      agent: _ctx.selectedAgent,
      onClose: ()=>{_ctx.selectedAgent = null}
    }, null, 8, ["agent", "onClose"])
  ], 64))
}